export const getStyles = () => ({
  animationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .ms-ProgressIndicator': {
      width: 370,
      marginTop: 30,
      '@media (max-width:600px)': {
        width: 200,
      },
    },
  },
});

export const getStylesForFluentUi = mobileDeviceQuery => ({
  animationImage: {
    root: {
      minHeight: 240,
      marginTop: 34,
    },
    image: {
      maxHeight: 310,
      [mobileDeviceQuery]: {
        width: '100%',
      },
    },
  },
  animationLabel: {
    root: {
      textAlign: 'center',
      fontSize: 12,
      fontWeight: 'normal',
    },
  },
});
